<template>
  <div
    class="w-80 h-80 border border-solid border-grey-200 rounded-lg flex flex-col bg-white"
  >
    <div class="flex flex-grow">
      <slot name="content"></slot>
    </div>
    <div class="flex h-20 border-t border-solid border-grey-200">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoPanel',
};
</script>
